import CircularProgress from '@mui/material/CircularProgress';
import { useState, useEffect, Fragment } from 'react';

import useFetch from "../../hooks/useFetch";
import { urlUser } from "../../helpers";
import { TableBasic } from "../../components/TableBasic";
import { TitlePage } from "../../components/TitlePage";
import { Stack } from "@mui/material";
import { FilterUser } from './components/FilterUser';



export const UserScreen = () => {

    const { data } = useFetch(urlUser);

    const [filterArray, setFilterArray] = useState([]);

    const [copyArray, setCopyArray] = useState(data);

    useEffect(() => {
        if (data) {
            setFilterArray(data);
            setCopyArray(data)
        };

    }, [data])

    return (
        <Stack width='100%' alignItems='center' mt={4}>
            <Stack width='95%'>
                <TitlePage subtitle={subtitle} buttonTitle={buttonTitle} title='Usuarios' />
                {data
                    ? <Fragment>
                        <FilterUser filterArray={filterArray} setFilterArray={setFilterArray} copyArray={copyArray}/>
                        <TableBasic rows={filterArray} setCopyArray={setCopyArray} setFilterArray={setFilterArray} tableTitle={tableTitle} colNames={colNames} values={values} />
                    </Fragment>
                    : <CircularProgress />
                }
            </Stack>
        </Stack>
    )
}

const colNames = ['Usuario', 'Teléfono', 'Rol', ''];
const values = ['email', 'tel', 'rol'];
const tableTitle = 'user';
const subtitle = 'Consulte datos de todos los usuarios';
const buttonTitle = 'Nuevo usuario';
